import Http from "@/commons/Http";
import VueBusiness from "@/business/VueBusiness";
import Utils from "@/commons/Utils.js";
import FrontBusiness from "@/business/FrontBusiness";
import RelatorioBusiness from "@/business/RelatorioBusiness";

const path = "api/layout-impressao";
export default {

  async getById(id){
    if(!Utils.testUUID(id)){
      return Promise.reject();
    }
    return Http.get(`${path}/${id}`);
  },

  async getSimpleList(){
    return Http.get(`${path}/simple`);
  },

  async getAll(resetCache = ''){
    return Http.get(`${path}${resetCache ? '?reset=' + resetCache : ''}`);
  },

  async save(dto, id = ''){
    return Http.post(`${path}/${id}`, dto);
  },

  async confirmarDpiAlto(dpiDigitalizacao, dpiDigitalizacaoOriginal = null) {
    if (dpiDigitalizacao !== 'ALTO' || dpiDigitalizacaoOriginal === 'ALTO') {
      return;
    }

    let result = await FrontBusiness.openConfirmacao(
      "A qualidade <strong>Alta</strong> pode aumentar o tempo de geração da impressão e, em documentos com muitas imagens, o processo pode não ser concluído.",
      "Tem certeza de que deseja utilizar a qualidade <strong>Alta</strong>?",
      "Sim, quero usar a qualidade alta"
    );

    if(result !== 'confirm') {
      throw 'Ação cancelada pelo usuário';
    }
  },

  textoAjudaQualidadeImagem() {
    return `
      <p>
        Define a qualidade utilizada ao converter PDFs anexados em imagens durante a impressão.
        A opção <strong>Médio</strong> atende à maioria dos documentos. Use <strong>Alto</strong> apenas quando precisar de maior
        nitidez, pois arquivos com muitas imagens podem levar mais tempo para gerar e,
        em alguns casos, podem não ser concluídos.
      </p>
    `;
  },

  async listByTipo(tipo){
    return Http.get(`${path}/${tipo}/simples`).then(l => l.map(i => {
      i.configuracao = JSON.parse(i.configuracao || '{}');
      i.atribuicao = JSON.parse(i.atribuicao || '[]');
      return i;
    }));
  },

  async listByTipoIds(tipo, ids){
    return Http.post(`${path}/${tipo}/simples`, ids).then(l => l.map(i => {
      i.configuracao = JSON.parse(i.configuracao || '{}');
      return i;
    }));
  },

  getEntidade(livro) {
    switch (livro) {
      case 'REGISTRO_AUXILIAR':
        return 'registro-auxiliar';
      case 'REGISTRO_TD':
      case 'REGISTRO_PJ':
      case 'REGISTRO_NOTAS':
        return 'indicador';
      default:
        return 'indicador-real';
    }
  },

  imprimirFichaUrl(livro, layout, indicador, version = 1){
    return `${path}/${layout}/imprimir/v${version}/${this.getEntidade(livro)}/${indicador}`;
  },

  async imprimirFichaLote(livro, layout, config){

    const l = livro == 'REGISTRO_AUXILIAR' ? 'registro-auxiliar' : 'indicador-real';

    return Http.post(`${path}/${layout}/imprimir-lote//${l}`, config, {
      responseType: 'blob',
      timeout : 0,
      headers: {'Content-Type': 'application/json'}
    }).then(response => {
      return new Blob([response], {type: "application/pdf"});
    });

  },

  simularRecibo(layout, protocolo){
    return `${path}/${layout}/recibo/${protocolo}/simular`;
  },

  recibo(layout, protocolo, params = '', fullUrl = false) {
    const base = fullUrl ? window.server.API + '/' + path : path;
    return `${base}/${layout}/recibo/${protocolo}?${params}`;
  },

  reciboComplementar(layout, protocolo, lancamento){
    return `${path}/${layout}/recibo/${protocolo}/complementar/${lancamento}`;
  },

  reciboSolicitacao(layout, protocolo, lancamento){
    return `${path}/${layout}/recibo/${protocolo}/solicitacao-valor/${lancamento}`;
  },

  async imprimirFirma({versaoId, servicoId}) {
    const config = {
      responseType: 'blob',
      timeout : 0,
      headers: {'Content-Type': 'application/json'}
    };

    let promise = Http.get(`${path}/imprimir-firma/${versaoId}${servicoId ? '/'+servicoId : ''}`, config);

    let pdf = await promise.then(response => new Blob([response], {type: "application/pdf"}));

    FrontBusiness.downloadFile(pdf, name);
  },

  imprimirFirmaURL({versaoId, servicoId}) {
    return `${path}/imprimir-firma/${versaoId}${servicoId ? '/'+servicoId : ''}`;
  },

  async etiquetar(formData) {
    let config = {
      timeout: 0,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    };

    return Http.post(`${path}/etiquetar`, formData, config);
  },

  async baixarEtiquetasRelatoriosEmLoteZIP(dados, assinarArquivar = false) {
    const config = {
      responseType: 'blob',
      timeout: 0,
      headers: { 'Content-Type': 'application/json' }
    };

    const caminho = assinarArquivar
      ? `${path}/baixar-etiquetas-relatorios-em-lote-zip/true`
      : `${path}/baixar-etiquetas-relatorios-em-lote-zip/false`;

    let promise = Http.post(caminho, dados, config);

    try {
      const response = await promise;

      const arquivo = new Blob([response], { type: 'application/zip' });

      FrontBusiness.downloadFile(arquivo, name);
      return;
    } catch (e) {

      if (e?.message) {
        FrontBusiness.showError('', e.message);
      } else {
        const text = await e.text();
        const res = JSON.parse(text);
        FrontBusiness.showError('', res?.message || 'Erro na geração do arquivo ZIP');
      }

      throw e;
    }
  },

  async baixarEtiquetasRelatoriosEmLotePdfUnico(dados, assinarArquivar = false) {
    const config = {
      responseType: 'blob',
      timeout: 0,
      headers: { 'Content-Type': 'application/json' }
    };

    const caminho = assinarArquivar
      ? `${path}/baixar-etiquetas-relatorios-em-lote-pdf-unico/true`
      : `${path}/baixar-etiquetas-relatorios-em-lote-pdf-unico/false`;

    try {
      const response = await Http.post(caminho, dados, config);

      const arquivo = new Blob([response], { type: 'application/pdf' });
      FrontBusiness.downloadFile(arquivo, 'baixar-etiquetas-relatorios-lote.pdf');

    } catch (e) {
      if (e.response && e.response.data instanceof Blob) {
        try {
          const text = await e.response.data.text();
          const json = JSON.parse(text);
          FrontBusiness.showError('', json?.message || 'Erro ao gerar PDF');
        } catch {
          FrontBusiness.showError('', 'Erro ao gerar PDF');
        }
      } else {
        FrontBusiness.showError('', e.message || 'Erro ao gerar PDF');
      }

      throw e;
    }
  },

  async enfileirarImpressaoIndicador(layout, indicador, dto) {
    return Http.post(`${path}/${layout}/imprimir/v3/indicador/${indicador}/fila`, dto);
  },

  async statusFilaImpressaoIndicador(indicador) {
    return Http.get(`${path}/impressao/v3/indicador/${indicador}/fila/status`);
  },

  async etiquetasServicos(protocoloId, custaAdicionalIds) {
    const config = {
      responseType: 'blob',
      timeout: 60000,
      headers: { 'Content-Type': 'application/json' }
    };
    const response = await Http.post(`${path}/etiquetas-servicos/${protocoloId}`, custaAdicionalIds, config);
    const arquivo = new Blob([response], { type: 'application/pdf' });
    FrontBusiness.downloadFile(arquivo, 'etiquetas-servicos.pdf');
  },

  async etiquetaServico(protocoloId, custaAdicionalId) {
    const config = {
      responseType: 'blob',
      timeout: 60000
    };
    const response = await Http.get(`${path}/etiquetas-servicos/${protocoloId}/${custaAdicionalId}`, config);
    const arquivo = new Blob([response], { type: 'application/pdf' });
    FrontBusiness.downloadFile(arquivo, 'etiqueta-servico.pdf');
  },

  async imprimirEtiquetasServicos(protocoloId, custaAdicionalIds = []) {
    const blob = await RelatorioBusiness.getPdfBlob(`${path}/etiquetas-servicos/${protocoloId}`, 'POST', custaAdicionalIds);
    FrontBusiness.imprimirPdf(blob, 'Etiquetas de Serviços');
  },

  getTipos() {
    let tipos = [
      {id: 'MATRICULA', nome: 'Matrícula'},
      {id: 'REGISTRO_AUXILIAR', nome: 'Registro Auxiliar'},
      {id: 'TRANSCRICAO', nome: 'Transcrição'},

      {id: 'MATRICULA_V2', nome: 'Matrícula - Nova Impressão'},
      {id: 'REGISTRO_AUXILIAR_V2', nome: 'Registro Auxiliar - Nova Impressão'},

      {id: 'MATRICULA_V3', nome: 'Matrícula - Nova Impressão [Experimental]'},
      {id: 'REGISTRO_AUXILIAR_V3', nome: 'Registro Auxiliar - Nova Impressão [Experimental]'},

      {id: 'CERTIDAO', nome: 'Certidão'},
      {id: 'CERTIDAO_V3', nome: 'Certidão - Nova Impressão [Experimental]'},
      {id: 'INCRA', nome: 'Relatório Incra'},
      {id: 'RELATORIO_IMOVEIS_URBANOS', nome: 'Relatório de Imóveis Urbanos'},
      {id: 'EXTRATO_DIARIO_RECEITAS_DESPESAS', nome: 'Extrato Diário de Receitas e Despesas'},

      {id: 'FIRMA', nome: 'Firma'},
    ];

    if (VueBusiness.getVueRoot().isRTD) {
      tipos.push({id: 'REGISTRO_TD', nome: 'Registro RTD'});
      tipos.push({id: 'REGISTRO_TD_V3', nome: 'Registro RTD - Nova Impressão'});
    }

    if (VueBusiness.getVueRoot().isRCPJ) {
      tipos.push({id: 'REGISTRO_PJ', nome: 'Registro RCPJ'});
      tipos.push({id: 'REGISTRO_PJ_V3', nome: 'Registro RCPJ - Nova Impressão'});
    }

    if (VueBusiness.getVueRoot().isNotas) {
      tipos.push({id: 'ATO_NOTARIAL', nome: 'Ato Notarial'});
    }

    tipos = [...tipos, ... [
      {id: 'EXTRATO', nome: 'Extratos e Recibos'},
      {id: 'ETIQUETA', nome: 'Etiqueta'},

      {id: 'NOTIFICACAO', nome: 'Notificação'},
      {id: 'OFICIO', nome: 'Ofício'},
      {id: 'LIVRO_ESTRANGEIRO', nome: "Livro Estrangeiro"},
      {id: 'TERMO_PERSONALIZADO', nome: 'Termo Personalizado'},
      {id: 'CNM', nome: 'CNM'},

    ]];
    if(VueBusiness.getVueRoot().isEstadoRS){
      tipos.push({id: 'RECIBO_FINAL', nome: 'Recibo Final'});
    }
    return tipos;
  },

  getTiposElemento() {
    return [
      {id: 'TEXT', nome: 'Texto'},
      {id: 'SQUARE', nome: 'Quadro/Linha'},
      {id: 'DATE_ATO', nome: 'Data do Ato'},
      {id: 'DATE_SELO_ATO', nome: 'Data Selagem do Ato'},
      {id: 'BRASAO_ESTADUAL', nome: 'Brasão Estadual'},
      {id: 'ANEXO', nome: 'Anexo'},
      {id: 'SQUARE_TEXT', nome: 'Quadro/Texto'}
    ];
  },

  getModosElemento() {
    return [
      {id: 'NOVA', nome: 'Novas Folhas'},
      {id: 'ENCERRAMENTO', nome: 'Folhas Encerradas'},
      {id: 'ANDAMENTO', nome: 'Folhas em Andamento'}
    ];
  },

}
